/* Face check page — behaviours bolted onto the scan engine.

   The scan engine itself lives in the page body in Shopify admin, not in the
   theme. This file deliberately does not touch it: everything below works
   from the outside.

     1. KEEP THE VIDEO PLAYING  (the model warm-up moved to face-check-warm.js)
     2. SAY 'PLEASE WAIT'     (only when there is a wait worth explaining)
     3. CARRY THE READER ON   (to whichever answer they came for)
     4. NO EMPTY MEASUREMENT ROWS  (hide what the engine could not read)
     5. NEVER ASK ANYONE TO SCAN AGAIN

   Loaded only on /pages/face-check, from layout/theme.liquid. */


/* ============================================================
   1. KEEP THE VIDEO PLAYING

   THE WARM-UP HAS MOVED  (23 Sep 2026)
   This section used to add six <link rel="prefetch"> tags for MediaPipe's
   files so the engine's own loader would find them in cache. That was the
   right idea with the wrong tool: a prefetch is a hint the browser is free
   to ignore, and Chrome ignores it precisely on slow connections and in
   Data Saver mode — the connections that needed the head start. It now
   lives in assets/face-check-warm.js as real fetches with a progress bar,
   and it holds the I'M READY button until the files are in. The prefetch
   tags are gone from here so the same 5 MB is never requested twice.

   The warm-up file is loaded from HERE rather than from layout/theme.liquid
   so the layout — the one file every page depends on — did not have to be
   rewritten for a change that touches only this page. Its address is this
   file's own, with the name swapped, so it follows the theme wherever the
   theme is copied.

   What stays is the video nudge below. */
(function(){
  if(!document.getElementById('bt-stage')) return;

  try{
    var me = document.currentScript && document.currentScript.src;
    if(me && me.indexOf('face-check-page.js') > -1){
      var w = document.createElement('script');
      w.src = me.replace('face-check-page.js', 'face-check-warm.js');
      w.async = true;
      document.head.appendChild(w);
    }
  }catch(e){}

  /* ---- Nudge the video into playing ----
     The page sets srcObject and relies on the autoplay attribute. A muted,
     playsinline video normally starts on its own, but when it does not — some
     iOS versions after a tab switch, some in-app browsers, Low Power Mode —
     nothing else recovers: the frame pump waits for readyState to rise, it
     never does, and the scan sits there until the forty-second timeout gives
     up with a message about lighting.

     Watched rather than hooked, because the page owns the element. */
  var vid = document.getElementById('bt-video');
  if(vid){
    var checks = 0;
    var poll = setInterval(function(){
      checks++;
      if(vid.srcObject && vid.paused){
        var p = vid.play();
        if(p && p.catch) p.catch(function(){});
      }
      if(checks > 120) clearInterval(poll);
    }, 1000);
  }
})();


/* ============================================================
   2. SAY 'PLEASE WAIT' — BUT ONLY IF THERE IS ACTUALLY A WAIT

   WHERE THE WAIT IS
   Not before the camera — after it. Tapping I'M READY opens the camera almost
   at once, and the person then sees their own face sitting there under
   'Starting the camera' while the face model finishes loading. No frame can be
   measured until it has arrived. That gap is the one that reads as broken: the
   camera is visibly working, so the obvious conclusion is that the site is not.

   Since 23 Sep the files are downloaded before the tap (face-check-warm.js),
   so this wait is now the model's own start-up — unpacking and compiling —
   rather than a download, and it is short. The notice stays for the cases
   where the warm-up could not run.

   WHY IT WAITS THREE SECONDS FIRST
   Because most of the time there is nothing to explain. With the model already
   warmed, scanning usually begins almost immediately, and a 'please wait' that
   flashes up and vanishes is worse than silence — it draws the eye to a
   problem that was not there, and makes a fast page feel like a slow one that
   got lucky. Three seconds is roughly where a pause stops reading as the
   machine working and starts reading as the machine stuck.

   IT ALWAYS CLEARS ITSELF, and the PENDING TIMER is cancelled too — otherwise
   a scan that begins at 2.9 seconds would pop the notice up a tenth of a
   second later, over an already-working camera. */
(function(){
  var stage = document.getElementById('bt-stage');
  var start = document.getElementById('bt-start');
  var step  = document.getElementById('bt-step');
  if(!stage || !start || !('MutationObserver' in window)) return;

  var DELAY = 3000;   /* how long a silent wait is allowed to run */

  var note = null, pending = null, failsafe = null, showing = false;

  function build(){
    if(note) return note;

    note = document.createElement('div');
    note.className = 'bt-wait';
    note.setAttribute('role', 'status');
    note.setAttribute('aria-live', 'polite');

    var spin = document.createElement('span');
    spin.className = 'bt-wait-spin';
    spin.setAttribute('aria-hidden', 'true');

    var head = document.createElement('b');
    head.textContent = 'Please wait';

    var sub = document.createElement('span');
    sub.className = 'bt-wait-sub';
    sub.textContent = 'Getting ready to read your face. The first scan takes a ' +
                      'few seconds to load — after that it is instant.';

    note.appendChild(spin);
    note.appendChild(head);
    note.appendChild(sub);
    stage.appendChild(note);
    return note;
  }

  function arm(){
    if(showing || pending) return;
    pending = setTimeout(function(){
      pending = null;
      showing = true;
      build().style.display = 'flex';
      failsafe = setTimeout(clear, 45000);
    }, DELAY);
  }

  function clear(){
    clearTimeout(pending);  pending = null;
    clearTimeout(failsafe); failsafe = null;
    if(!showing) return;
    showing = false;
    if(note) note.style.display = 'none';
  }

  function visible(el){
    return !!(el && el.style.display && el.style.display !== 'none');
  }

  new MutationObserver(function(){
    if(start.style.display === 'none') arm();
  }).observe(start, { attributes:true, attributeFilter:['style'] });

  if(step){
    new MutationObserver(function(){
      if(visible(step)) clear();
    }).observe(step, { attributes:true, attributeFilter:['style'] });
  }

  var trouble = document.getElementById('bt-trouble');
  if(trouble){
    new MutationObserver(function(){
      if(visible(trouble)) clear();
    }).observe(trouble, { attributes:true, attributeFilter:['style'] });
  }
})();


/* ============================================================
   3. CARRY THE READER ON TO WHICHEVER ANSWER THEY CAME FOR

   The result opens on the mesh, the measurements and the verdict — the proof,
   and people should see it. But the thing they actually came for is further
   down, and WHICH thing depends on how they arrived:

     FROM A PRODUCT PAGE  (/pages/face-check?p=the-charmer)
       They asked one question about one frame: does this suit me. The answer
       is the verdict and the ADD TO BAG button under it. Landing them in
       'Suits you most' instead answers a question they did not ask, with a
       list of OTHER frames — which reads as 'no, try these' even when the
       verdict just said yes. It walks them away from the thing they were
       already holding, at the exact moment they were closest to buying it.

     STRAIGHT TO THE PAGE
       No frame in mind, so the recommendations ARE the answer and 'Suits you
       most' is the right landing.

   The target is read off what is on the page rather than off the URL, so a
   sold-out frame — where the page hides the bag button and shows the verdict
   with a link instead — still lands correctly, with no extra branch.

   ONE EXTRA MEASUREMENT. Aligning the top of the verdict under the header is
   the nicer framing, but on a short screen the buy button can then sit below
   the fold, which defeats the entire point of scrolling there. So it goes to
   whichever is further down: the verdict's top, or far enough that the whole
   button is visible.

   WHAT IT WILL NOT DO
   Move the page if the reader is already moving it themselves. Any wheel,
   touch, key or pointer input cancels it — before the scroll starts, and
   mid-flight too. */
(function(){
  var result = document.getElementById('bt-result');
  if(!result) return;

  var timer = null, raf = null;
  var armed = false, moved = false, tries = 0;

  var GLIDE = 1150;
  var GAP   = 24;   /* breathing room under the button */

  function reduced(){
    return window.matchMedia &&
           window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function shown(el){
    return !!(el && el.style.display !== 'none' && el.offsetParent !== null);
  }

  function scrollY(){
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  function absTop(el){
    return el.getBoundingClientRect().top + scrollY();
  }

  /* The header is sticky, so scrolling an element to the top of the viewport
     tucks it underneath. Measured rather than hard-coded — the bar is a
     different height on a phone than on a laptop. */
  function headroom(){
    var h = document.querySelector('.site-header--centre');
    return (h ? h.offsetHeight : 0) + 14;
  }

  /* Where to land, or null if the page is not ready yet — the verdict and the
     tiers are filled from /products.json, so on a slow connection they can
     still be empty when the timer fires. */
  function targetY(){
    var verdict = document.getElementById('bt-verdict');

    if(shown(verdict)){
      var y = absTop(verdict) - headroom();

      /* Came from a product AND it is buyable: make sure the BUTTON is on
         screen, not merely the panel it lives in. */
      var cart = document.getElementById('bt-cartwrap');
      var btn  = document.getElementById('bt-add');
      if(shown(cart) && btn){
        var needed = absTop(btn) + btn.offsetHeight - window.innerHeight + GAP;
        if(needed > y) y = needed;
      }
      return y;
    }

    var tier = document.getElementById('bt-tier1');
    if(shown(tier)) return absTop(tier) - headroom();

    return null;
  }

  function stopGlide(){
    if(raf){ cancelAnimationFrame(raf); raf = null; }
  }

  /* Ease in, ease out. A linear scroll starts and stops abruptly, which is
     what makes an automatic one feel like something done TO you rather than
     something that moved. */
  function ease(t){
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function glideTo(target){
    var from = scrollY();
    var max  = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var to   = Math.min(Math.max(0, target), max);
    var span = to - from;

    if(Math.abs(span) < 4) return;
    if(reduced()){ window.scrollTo(0, to); return; }

    var t0 = null;
    stopGlide();

    raf = requestAnimationFrame(function step(now){
      if(moved){ stopGlide(); return; }   /* they took over mid-flight */
      if(t0 === null) t0 = now;
      var p = Math.min(1, (now - t0) / GLIDE);
      window.scrollTo(0, from + span * ease(p));
      raf = p < 1 ? requestAnimationFrame(step) : null;
    });
  }

  function go(){
    if(moved) return;

    var y = targetY();
    if(y === null){
      /* Wait for the content rather than scrolling to a heading with nothing
         under it — but give up after a few goes rather than chasing it. */
      if(tries++ < 4){ timer = setTimeout(go, 1200); }
      return;
    }

    glideTo(y);
  }

  function arm(){
    if(armed) return;
    armed = true; moved = false; tries = 0;
    clearTimeout(timer);
    timer = setTimeout(go, 3000);
  }

  function disarm(){
    armed = false;
    clearTimeout(timer);
    timer = null;
    stopGlide();
  }

  ['wheel','touchstart','touchmove','keydown','pointerdown'].forEach(function(ev){
    window.addEventListener(ev, function(){
      if(armed){ moved = true; stopGlide(); }
    }, {passive:true});
  });

  if(!('MutationObserver' in window)) return;

  new MutationObserver(function(){
    if(shown(result)) arm(); else disarm();
  }).observe(result, { attributes:true, attributeFilter:['style'] });

  if(shown(result)) arm();
})();


/* ============================================================
   4. NEVER SHOW A MEASUREMENT ROW WITH NOTHING IN IT

   WHAT WENT WRONG
   A creator ran the scan repeatedly and every time got four empty rows —
   Face width, Face length, Forehead, Jaw width — each showing an em dash,
   with "Frame width to aim for" falling back to the size guide and a note
   telling her to rescan in better light. The scan had in fact worked: the
   mesh, the shape reading and the recommendations were all correct. Only the
   millimetre half failed, and it failed the same way on every attempt.

   WHY IT FAILS
   The engine sizes a face by using the iris as a ruler — an iris is about
   11.7mm across on almost everybody — and then sanity-checks the answer
   against a 115-170mm band. Run the same landmark maths over a clean,
   straight-on, high-resolution face and it returns about 123mm. That is only
   8mm of headroom. A live selfie is dimmer, smaller and never perfectly
   square to the lens, and a narrower face starts lower still, so falling
   under 115 is ordinary rather than exceptional. When it does, every
   millimetre value is discarded at once.

   WHY THIS FIXES THE SYMPTOM AND NOT THE CAUSE
   The band and the estimator live in the page body in Shopify admin, which
   goes live the instant it is saved and has no preview. Widening the band
   there would also be the wrong move on its own: the estimate reads low, and
   the number drives a frame-width recommendation, so a looser band would hand
   more people a size that is too small. That is worse than handing them
   nothing. So the theme does the honest half: if there is no number, there is
   no row.

   HOW
   The four millimetre rows are hidden the moment this file runs, and revealed
   only if a real figure arrives. Hiding on sight rather than after the fact is
   what stops a flash of dashes — the whole block is display:none until the
   result is ready, so pre-hiding costs nothing. The sentences that blame the
   light are stripped from the note, because rescanning cannot fix this and
   sending someone off to try is worse than saying nothing.

   THE THIRD STRIP  (added 2026-09-14)
   "Close between two builds — rescan in better light if it feels off" is a
   different sentence with the same defect: it fires when the top two shape
   scores are within 18% of each other, which is a property of the face, not
   of the lighting. Rescanning a face that sits between two builds returns
   that it sits between two builds. The honest half of it — that the call was
   close — is already carried by the verdict copy.

   What remains is a complete, true result: Cheek to jaw, Jaw angle, Cheek
   depth, and the size guide link. Which is what she should have seen. */
(function(){
  var specs = document.getElementById('bt-specs');
  if(!specs) return;

  var MM_IDS = ['bt-sp1','bt-sp2','bt-sp3','bt-sp4'];
  var HIDE = 'bt-mm-empty';

  try{
    var st = document.createElement('style');
    st.textContent = '#bt-specs .' + HIDE + '{display:none !important}';
    document.head.appendChild(st);
  }catch(e){}

  function rows(){
    var out = [];
    for(var i = 0; i < MM_IDS.length; i++){
      var b = document.getElementById(MM_IDS[i]);
      var row = b && b.closest ? b.closest('.bt-spec') : null;
      if(row) out.push(row);
    }
    return out;
  }

  /* A real reading always contains a digit. An em dash, an en dash, an empty
     string and a stray space all count as nothing. */
  function hasNumber(el){
    return !!(el && /[0-9]/.test(el.textContent || ''));
  }

  var STRIP = [
    /\s*We could not see your eyes clearly enough to measure in millimetres,[^.]*\./g,
    /\s*The millimetre scaling did not look reliable on this scan,[^.]*\.\s*Better light and a straight-on angle will fix it\./g,
    /\s*Close between two builds[^.]*\./g
  ];

  function tidyNote(){
    var note = document.getElementById('bt-spnote');
    if(!note) return;
    var txt = note.textContent || '';
    var out = txt;
    for(var i = 0; i < STRIP.length; i++) out = out.replace(STRIP[i], '');
    out = out.replace(/\s{2,}/g, ' ').trim();
    if(out !== txt) note.textContent = out;
  }

  function paint(){
    var show = hasNumber(document.getElementById('bt-sp1'));
    var list = rows();
    for(var i = 0; i < list.length; i++){
      list[i].classList.toggle(HIDE, !show);
    }
    tidyNote();
  }

  /* Hidden from the start, revealed only on evidence. */
  paint();

  if('MutationObserver' in window){
    new MutationObserver(paint).observe(specs, {
      childList: true, subtree: true, characterData: true
    });
  }else{
    setInterval(paint, 800);
  }
})();


/* ============================================================
   5. NEVER ASK ANYONE TO SCAN AGAIN

   THE RULE
   Once a scan has produced a result, the page does not suggest doing it
   again. Not in the copy, not as a button.

   WHY
   A rescan almost never changes the answer. The shape reading is stable —
   the same face in the same room gives the same verdict — and the part that
   most often looks wrong, the millimetre block, fails for reasons a second
   attempt cannot touch (see section 4). So an invitation to try again is an
   invitation to get the identical result a second time, and the natural
   reading of that is not "my lighting was fine after all", it is "this thing
   is broken". A creator did exactly this: several scans, same outcome each
   time, and she came away thinking the feature did not work. The feature
   worked. The retry prompt is what made it look otherwise.

   WHAT IS REMOVED
   a) RESCAN, at the top of the result.
   b) SCAN AGAIN, at the bottom of the result.
   c) The instruction inside the glasses note. The note itself stays, because
      it is true and useful — if we think someone had glasses on, the fit is
      approximate and they deserve to know. Only the "take them off and scan
      again" half goes: it is the sentence that sends them round the loop.

   Two buttons, at both ends of the same result, both doing resetToScan. The
   bottom one was dealt with first and the top one was missed — worth saying
   plainly, because the lesson is that this page is edited in Shopify admin
   where nothing is diffed and nothing is reviewed. Anything added there can
   reintroduce a prompt this file is trying to suppress, and the only defence
   is to check the rendered page rather than trust the last known state.

   WHAT IS DEFINITELY NOT REMOVED
   TRY AGAIN on the trouble panel. That one appears only when a scan did NOT
   finish — a refused camera, a dark room, a face turned too far — and in
   every one of those cases trying again is the fix, and it is the only way
   forward besides the size guide. Removing it would strand people.

   The buttons are hidden with a rule rather than an inline style, because the
   scan engine in the page body sets display on them and would otherwise put
   them straight back. The note is watched, because the engine rewrites its
   text each time a result lands. */
(function(){
  var IDS  = ['bt-again', 'bt-rescan-top'];
  var warn = document.getElementById('bt-specswarn');

  var found = [];
  for(var i = 0; i < IDS.length; i++){
    var el = document.getElementById(IDS[i]);
    if(el) found.push(el);
  }
  if(!found.length && !warn) return;

  /* ---- a) the buttons ---- */
  if(found.length){
    try{
      var sel = [];
      for(var j = 0; j < IDS.length; j++) sel.push('#' + IDS[j]);
      var st = document.createElement('style');
      st.textContent = sel.join(',') + '{display:none !important}';
      document.head.appendChild(st);
    }catch(e){}

    /* Collapse the wrapper too, so its margin does not leave a gap where the
       button used to be. Only when the button is all it holds — otherwise
       something else would vanish with it. */
    for(var k = 0; k < found.length; k++){
      var wrap = found[k].parentNode;
      if(wrap && wrap.children && wrap.children.length === 1){
        wrap.style.display = 'none';
      }
    }
  }

  /* ---- b) the sentence ---- */
  if(!warn) return;

  var RESCAN = /\s*Take them off and scan again for a proper one\.?/g;

  function tidyWarn(){
    var txt = warn.textContent || '';
    var out = txt.replace(RESCAN, '').replace(/\s{2,}/g, ' ').trim();
    if(out !== txt) warn.textContent = out;
  }

  tidyWarn();

  if('MutationObserver' in window){
    new MutationObserver(tidyWarn).observe(warn, {
      childList: true, subtree: true, characterData: true
    });
  }else{
    setInterval(tidyWarn, 800);
  }
})();
